import React from 'react';
import { Chip, Typography, useTheme } from '@mui/material';
import { LdtOrderDetailFieldsFragment } from 'src/types';
import { isCustomerSuccessOrSalesUser } from 'src/utils';

export type LdtOrderDetailHeaderExtraOrder = Pick<
  LdtOrderDetailFieldsFragment,
  'bxlinkEncounterId' | 'bxlinkAccession' | 'externalId'
>;

/**
 * LDT-specific header extras: Encounter ID and Accession ID for CS/Sales users.
 */
export const LdtOrderDetailHeaderExtra: React.FC<{
  order: LdtOrderDetailHeaderExtraOrder;
}> = ({ order }) => {
  const theme = useTheme();
  const isCSOrSalesUser = isCustomerSuccessOrSalesUser();
  const showEncounterId = isCSOrSalesUser && !!order.bxlinkEncounterId?.trim();
  const showAccessionId = isCSOrSalesUser && !!order.bxlinkAccession?.trim();
  const showTempusOrderId = isCSOrSalesUser && !!order.externalId?.trim();

  if (!showEncounterId && !showAccessionId && !showTempusOrderId) {
    return null;
  }

  return (
    <>
      {showTempusOrderId && (
        <Chip
          label={
            <Typography variant='body2'>
              {`Tempus ID (OHID): `}
              <Typography
                component='span'
                variant='body2'
                color='primary'
                sx={{
                  fontWeight: theme.typography.fontWeightMedium,
                }}
              >
                {order.externalId}
              </Typography>
            </Typography>
          }
          sx={{
            backgroundColor: theme.palette.action.hover,
          }}
        />
      )}
      {showEncounterId && (
        <Chip
          label={
            <Typography variant='body2'>
              {`Encounter ID: `}
              <Typography
                component='span'
                variant='body2'
                color='primary'
                sx={{
                  fontWeight: theme.typography.fontWeightMedium,
                }}
              >
                {order.bxlinkEncounterId}
              </Typography>
            </Typography>
          }
          sx={{
            backgroundColor: theme.palette.action.hover,
          }}
        />
      )}
      {showAccessionId && (
        <Chip
          label={
            <Typography variant='body2'>
              {`Accession ID: `}
              <Typography
                component='span'
                variant='body2'
                color='primary'
                sx={{
                  fontWeight: theme.typography.fontWeightMedium,
                }}
              >
                {order.bxlinkAccession}
              </Typography>
            </Typography>
          }
          sx={{
            backgroundColor: theme.palette.action.hover,
          }}
        />
      )}
    </>
  );
};
